import React, { useState, useEffect } from "react"
import { Button, OverlayTrigger, Popover } from "react-bootstrap"

import {
  id_accessor,
  isLTPM,
  withRunEventLabelState,
} from "../../../../../components/shared_components_registration"
import CreateRunEventLabelModal from "./CreateRunEventLabelModal"
import { graphsEqual } from "../../../resources/utils"
import EditRunEventLabelModal from "./EditRunEventLabelModal"
import ToggleEventLayers from "./ToggleEventLayers"
import CompleteRunEventLabelingModal from "./CompleteRunEventLabelingModal"
import { updateObject } from "../../../../../Loaders"
import { logToServer } from "../../../../../ErrorBoundary"
import { parseDate } from "../../../../utils"
import { getStatusDetails } from "./LabelingCompleteLabel"

const ToggleRunLabelsButton = ({
  run,
  exportBaseName,
  small = false,
  op = {},
  plotImageSettings = {},
  PlotImage,
  runEventRegistration, // From RunLabelConfigProvider
  addingRunEventLabel, // From RunLabelConfigProvider
  setAddingRunEventLabel, // From RunLabelConfigProvider
  newLabelSelection, // From RunLabelConfigProvider
  setNewLabelSelection, // From RunLabelConfigProvider
}) => {
  if (isLTPM) {
    return <></>
  }

  const [showCreateModal, setShowCreateModal] = useState(false)
  useEffect(() => {
    newLabelSelection?.runID && setShowCreateModal(true)
  }, [newLabelSelection])
  const [showEditModal, setShowEditModal] = useState(false)

  const [validRunEventOpts, setValidRunEventOpts] = useState([])
  useEffect(() => {
    setValidRunEventOpts(
      runEventRegistration.filter((e) => (e.applicable_reactors?.[run.site] || []).includes(run.reactor)),
    )
  }, [runEventRegistration, run])

  const [showCompleteModal, setShowCompleteModal] = useState(false)

  const handleStatusToggle = (e) => {
    e.preventDefault()

    run?.[id_accessor] &&
      run?.updateRunMetadata &&
      updateObject(`/warehouse/runlabels/${run?.[id_accessor]}/complete_runreactor_labeling/`, {})
        .then((resp) => {
          const data = resp?.data
          // Lightweight update labelingComplete status on run information currently in state
          data &&
            run.updateRunMetadata({
              labelingComplete: data.labeling_complete,
              labelingCompleteBy: data.updated_by,
              labelingCompleteOn: parseDate(data.updated_on),
            })
        })
        .catch((error) => {
          logToServer(error)
          console.error(error)
        })

    setShowCompleteModal(false)
  }

  const statusDetails = getStatusDetails(run?.labelingCompleteOn, run?.labelingCompleteBy)
  const statusTitle = run.labelingComplete ? "Mark Labeling as Incomplete?" : "Mark Labeling as Complete?"

  const overlay = (
    <Popover id="manage_run_events" title={"Manage Run Events"}>
      <Popover.Header as={"h3"}>{"Run Events"}</Popover.Header>
      <Popover.Body>
        <div style={{ textAlign: "center" }}>
          <ToggleEventLayers small={small} />
          <Button
            title={
              validRunEventOpts.length === 0
                ? `No Label Options Available for ${run.site}/${run.reactor}`
                : "Add Run Label"
            }
            variant={"outline-primary"}
            disabled={validRunEventOpts.length === 0}
            className={addingRunEventLabel ? "btn-selected" : ""}
            onClick={(e) => {
              e.preventDefault()
              $("#manage_run_events").hide()
              setAddingRunEventLabel(!addingRunEventLabel)
            }}
          >
            <span className={"fa fa-plus"} />
          </Button>
          <Button
            title={(run.runEventLabels || []).length === 0 ? "No Run Labels To Edit" : "Edit Run Labels"}
            variant={"outline-primary"}
            disabled={(run.runEventLabels || []).length === 0}
            onClick={(e) => {
              e.preventDefault()
              $("#manage_run_events").hide()
              setShowEditModal(true)
            }}
          >
            <span className={"fa fa-pencil-square-o"} />
          </Button>
          <Button
            title={statusDetails ? `${statusDetails}: ${statusTitle}` : statusTitle}
            variant={"outline-primary"}
            onClick={(e) => {
              e.preventDefault()
              $("#manage_run_events").hide()
              setShowCompleteModal(true)
            }}
          >
            <span className={`fa fa-${run.labelingComplete ? "check-square-o" : "square-o"}`} />
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    !isLTPM &&
    !["multi"].includes(op.special) && (
      <>
        {showCreateModal &&
          newLabelSelection?.runID === run[id_accessor] &&
          graphsEqual(op, newLabelSelection?.graphKey) && (
            <CreateRunEventLabelModal
              show={showCreateModal}
              onHide={() => {
                setShowCreateModal(false)
                setNewLabelSelection({})
              }}
              run={run}
              plotImageSettings={plotImageSettings}
              PlotImage={PlotImage}
              exportBaseName={exportBaseName}
              validRunEventOpts={validRunEventOpts}
            />
          )}
        {showEditModal && (
          <EditRunEventLabelModal
            show={showEditModal}
            exportBaseName={exportBaseName}
            onHide={() => {
              setShowEditModal(false)
            }}
            run={run}
            editLabel={(info) => {
              setNewLabelSelection({
                ...info,
                runID: run[id_accessor],
                graphKey: op,
              })
              setShowEditModal(false)
            }}
          />
        )}
        {showCompleteModal && (
          <CompleteRunEventLabelingModal
            onHide={() => setShowCompleteModal(false)}
            show={showCompleteModal}
            exportBaseName={exportBaseName}
            onConfirm={handleStatusToggle}
            run={run}
          />
        )}
        <OverlayTrigger trigger="click" placement={"bottom"} rootClose overlay={overlay}>
          <Button title={"Manage Run Events"} variant={"outline-primary"} className={small ? " btn-sm" : ""}>
            <span className={"fa fa-tag"} aria-hidden="true" />
          </Button>
        </OverlayTrigger>
      </>
    )
  )
}

export default withRunEventLabelState(ToggleRunLabelsButton)
